var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.901,
    height: 27.463,
    viewBox: "0 0 27.901 27.463",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat-icon",
    transform: "translate(-5.228 -54.268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1844",
    "data-name": "Grupo 1844",
    transform: "translate(5.228 54.268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1843",
    "data-name": "Grupo 1843"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_458",
    "data-name": "Trazado 458",
    d: "M1314.909,446.848l-1.621-4.717a11.77,11.77,0,0,0-2.188-13.43,11.779,11.779,0,0,0-20.185,8.1,8.587,8.587,0,0,0-2.606,10.552l-1.116,3.248a1.534,1.534,0,0,0,1.445,2.032,1.541,1.541,0,0,0,.5-.085l3.248-1.116a8.626,8.626,0,0,0,3.672.829h.009a8.577,8.577,0,0,0,6.938-3.526,11.82,11.82,0,0,0,4.869-1.191l4.716,1.62a1.838,1.838,0,0,0,.6.1,1.825,1.825,0,0,0,1.718-2.415Zm-18.834,3.752h-.011a6.946,6.946,0,0,1-3.226-.8.829.829,0,0,0-.658-.051l-3.331,1.145,1.145-3.331a.832.832,0,0,0-.051-.658,6.924,6.924,0,0,1,1.128-8.028,11.829,11.829,0,0,0,9.862,9.731A6.9,6.9,0,0,1,1296.075,450.6Zm17.225-3.046a.153.153,0,0,1-.167.039l-5.049-1.735a.829.829,0,0,0-.658.052,10.148,10.148,0,0,1-4.711,1.169h-.016a10.165,10.165,0,0,1-10.124-9.96,10.125,10.125,0,0,1,10.289-10.287,10.127,10.127,0,0,1,8.79,14.85.829.829,0,0,0-.052.658l1.735,5.049A.152.152,0,0,1,1313.3,447.553Z",
    transform: "translate(-1287.109 -425.168)",
    fill: "#acacac"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1846",
    "data-name": "Grupo 1846",
    transform: "translate(15.043 61.651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1845",
    "data-name": "Grupo 1845"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_459",
    "data-name": "Trazado 459",
    d: "M1308.5,433.194h-9.894a.831.831,0,0,0,0,1.661h9.894a.831.831,0,0,0,0-1.661Z",
    transform: "translate(-1297.777 -433.194)",
    fill: "#acacac"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1848",
    "data-name": "Grupo 1848",
    transform: "translate(15.043 65.067)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1847",
    "data-name": "Grupo 1847"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_460",
    "data-name": "Trazado 460",
    d: "M1308.5,436.907h-9.894a.83.83,0,0,0,0,1.661h9.894a.83.83,0,1,0,0-1.661Z",
    transform: "translate(-1297.777 -436.907)",
    fill: "#acacac"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1850",
    "data-name": "Grupo 1850",
    transform: "translate(15.043 68.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1849",
    "data-name": "Grupo 1849"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_461",
    "data-name": "Trazado 461",
    d: "M1304.692,440.619h-6.085a.83.83,0,0,0,0,1.66h6.085a.83.83,0,1,0,0-1.66Z",
    transform: "translate(-1297.777 -440.619)",
    fill: "#acacac"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.8977aaa030db76da2c2a8a3f70ecd3ec.svg";
export { ForwardRef as ReactComponent };